export { default } from './gtm';
export * as gtmUtils from './utils';
